<div class="client_tabs_menu">
    <div class="back_button_wrapper">
        <button
            @click="clickOnBackButton"
            class="button_back"
            v-show="backButton?.buttonPath"
        ><img class="back_button_img" src="/assets/img/arrow-left.svg"><span>{{backButton?.isNeedTranslatedButtonText && backButton?.buttonText ? $t(backButton.buttonText) : backButton?.buttonText }}</span></button>
    </div>

    <v-scrollable-menu :modelValue="activeTabItem" :items="tabs" :badges="badges" @update:modelValue="onTabClick"></v-scrollable-menu>
</div>
